import styled from 'styled-components';

export const UiRecordList = styled.div`
	display: block;
`;